// Localisation
//
var lang = document.getElementsByTagName("html")[0].getAttribute("lang");
if (lang == "fr" || lang == "fr-ca") {
    // Ref about import loader config : http://stackoverflow.com/a/28989476
    require('imports-loader?define=>false&jQuery=jquery!jquery-validation/dist/localization/messages_fr.js');
}


// WEBPACK FOOTER //
// ./Sig.Web/src/utils/forms-validation/localization.js